import React from 'react';
import { isEmpty } from 'lodash';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./system-message.i18n.json'));

import SystemMessage from './SystemMessage';

import type { SubcampaignInfluencerProfile } from 'types';

type Props = {
  metadata: {
    disagreementDetails?: {
      reason?: string,
      comment?: string
    }
  },
  text: string,
  influencerProfile: SubcampaignInfluencerProfile,
  isBrand: boolean
};

class SystemChatMessageOfferDeclined extends SystemMessage<Props> {
  render() {
    const {
      text,
      metadata,
      isBrand,
      influencerProfile
    } = this.props;

    const influencerName = !isEmpty(influencerProfile) && influencerProfile.name;
    const disagreementDetails = metadata.disagreementDetails;
    const disclaimer = __t('system_message.revoked_creator_description');

    return (
      <React.Fragment>
        {this.renderIcon('broken-heart-inside-circle-custom-fg')}
        <div className="messages-system-message__container">
          <div className="messages-system-message__bubble">
            <div className="messages-system-message__heading">
              {text}
            </div>
            {
              disagreementDetails && disagreementDetails.reason &&
                <div className="messages-system-message__paragraph">
                  <div className="messages-system-message__heading">
                    {__t('system_message.decline_reason')}:
                  </div>
                  <div>{disagreementDetails.reason}</div>
                </div>
            }
            {
              disagreementDetails && disagreementDetails.comment &&
                <div className="messages-system-message__paragraph">
                  {
                    influencerName && (
                      <div className="messages-system-message__heading">
                        {__t('system_message.decline_comment', { influencer: influencerName })}:
                      </div>
                    )
                  }
                  <div>{disagreementDetails.comment}</div>
                </div>
            }
            { !isBrand && this.renderDisclaimer(disclaimer) }
          </div>
        </div>
        {this.renderFooter()}
      </React.Fragment>
    );
  }
}

export default SystemChatMessageOfferDeclined;
